import { Z_INDEX } from '../../foundations/zIndex';
import { OverlayVariantType } from './variants';
export const getOverlayStyles = (FOUNDATIONS) => {
    return {
        [OverlayVariantType.DEFAULT]: {
            container: {
                position: 'fixed',
                top: '0',
                left: '0',
                z_index: Z_INDEX.OVERLAY,
                width: '100vw',
                height: '100vh',
                opacity: '0.7',
                background_color: FOUNDATIONS.color_neutral_bg_50,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map